module.exports = {
          srcSet: __webpack_public_path__ + "images/1898-f29234b1c3c7098f8d44fc4ea5ea6c53-320.jpg"+" 320w"+","+__webpack_public_path__ + "images/1898-ad24650f86cce9d700f916d7bf690f7e-370.jpg"+" 370w",
          images:[ {path: __webpack_public_path__ + "images/1898-f29234b1c3c7098f8d44fc4ea5ea6c53-320.jpg",width: 320,height: 251},{path: __webpack_public_path__ + "images/1898-ad24650f86cce9d700f916d7bf690f7e-370.jpg",width: 370,height: 290}],
          src: __webpack_public_path__ + "images/1898-f29234b1c3c7098f8d44fc4ea5ea6c53-320.jpg",
          toString:function(){return __webpack_public_path__ + "images/1898-f29234b1c3c7098f8d44fc4ea5ea6c53-320.jpg"},
          
          width: 320,
          height: 251
        }